export const environment = {
  production: false,
  securedRoutes: ['https://dnt-dev-as.azurewebsites.net'],
  apiUrl: 'https://dnt-dev-as.azurewebsites.net/api/v1',
  azTenant: '8619c67c-945a-48ae-8e77-35b1b71c9b98',
  azBEClientId: '6a43624a-7f46-4ed9-9022-1e92e90ed58c',
  instrumentationKey: '1fbce542-27f3-4c32-aab9-731bec5e602d',
  defaultLanguage: 'en',
};